import { useWeb3React } from "@web3-react/core";

export function fetchCount(amount = 1) {
  
  return new Promise<{ data: number }>((resolve) =>
    setTimeout(() => resolve({ data: amount }), 500)
  );
  
}
